export const IDLE = 'IDLE';

export const LOADING = 'LOADING';

export const SUCCEEDED = 'SUCCEEDED';

export const FAILED = 'FAILED';
